import { render, staticRenderFns } from "./Audit-Logs.vue?vue&type=template&id=56ea77c2&scoped=true"
import script from "./Audit-Logs.vue?vue&type=script&lang=js"
export * from "./Audit-Logs.vue?vue&type=script&lang=js"
import style0 from "./Audit-Logs.vue?vue&type=style&index=0&id=56ea77c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea77c2",
  null
  
)

export default component.exports